<template>
  <b-modal ref="driver-card-modal" @ok="driverCardModalOk">
    <template v-slot:modal-header="{}">
      <div>{{ $store.state.localization.data.mainPage.drivers.pageLabel }}</div>
    </template>
    <div style="font-size: 13px">
      <b-form-group
        label-cols-sm="4"
        label-cols-lg="3"
        content-cols-sm
        content-cols-lg="8"
        :label="$store.state.localization.data.mainPage.drivers.tableColumns.lastName"
        label-for="input-horizontal"
      >
        <b-form-input
          v-model="lastName"
          :state="isLastNameValid"
          style="font-size: 13px"
        ></b-form-input>
      </b-form-group>

      <b-form-group
        label-cols-sm="4"
        label-cols-lg="3"
        content-cols-sm
        content-cols-lg="8"
        :label="$store.state.localization.data.mainPage.drivers.tableColumns.firstName"
        label-for="input-horizontal"
      >
        <b-form-input
          v-model="firstName"
          :state="isFirstNameValid"
          style="font-size: 13px"
        ></b-form-input>
      </b-form-group>

      <b-form-group
        label-cols-sm="4"
        label-cols-lg="3"
        content-cols-sm
        content-cols-lg="8"
        :label="$store.state.localization.data.mainPage.drivers.tableColumns.patronymic"
        label-for="input-horizontal"
      >
        <b-form-input
          v-model="patronymic"
          style="font-size: 13px"
        ></b-form-input>
      </b-form-group>

      <b-form-group
        label-cols-sm="4"
        label-cols-lg="3"
        content-cols-sm
        content-cols-lg="8"
        locale="ua"
        :label="$store.state.localization.data.mainPage.drivers.tableColumns.birthDate"
        label-for="input-horizontal"
      >
        <b-form-datepicker
          v-model="birthDate"
          value-as-date="true"
          style="font-size: 13px"
          :locale="calendarLocale"
        ></b-form-datepicker>
      </b-form-group>

      <b-form-group
        label-cols-sm="4"
        label-cols-lg="3"
        content-cols-sm
        content-cols-lg="8"
        :label="$store.state.localization.data.mainPage.drivers.tableColumns.gender"
        label-for="input-horizontal"
      >
        <b-form-select
          v-model="gender"
          :state="isGenderValid"
          :options="genderOptions"
          style="font-size: 13px"
        ></b-form-select>
      </b-form-group>

      <b-form-group
        label-cols-sm="4"
        label-cols-lg="3"
        content-cols-sm
        content-cols-lg="8"
        :label="$store.state.localization.data.mainPage.drivers.tableColumns.rfid"
        label-for="input-horizontal"
      >
        <b-form-input
          v-model="rfid"
          :state="isRfidValid"
          style="font-size: 13px"
        ></b-form-input>
      </b-form-group>

      <b-form-group
        label-cols-sm="4"
        label-cols-lg="3"
        content-cols-sm
        content-cols-lg="8"
        :label="$store.state.localization.data.mainPage.drivers.tableColumns.phoneNumber"
        label-for="input-horizontal"
      >
        <b-form-input
          v-model="phoneNumber"
          style="font-size: 13px"
        ></b-form-input>
      </b-form-group>

      <b-form-group
        label-cols-sm="4"
        label-cols-lg="3"
        content-cols-sm
        content-cols-lg="8"
        :label="$store.state.localization.data.mainPage.drivers.tableColumns.vehicleRegisterNumber"
        label-for="input-horizontal"
      >
        <b-form-select
          v-model="vehicleId"
          :options="vehicleOptions"
          style="font-size: 13px"
        ></b-form-select>
      </b-form-group>

      <b-form-group
        label-cols-sm="4"
        label-cols-lg="3"
        content-cols-sm
        content-cols-lg="8"
        :label="$store.state.localization.data.mainPage.drivers.tableColumns.company"
        label-for="input-horizontal"
      >
        <b-form-select
          v-model="companyId"
          :state="isCompanyValid"
          :options="companyOptions"
          style="font-size: 13px"
        ></b-form-select>
      </b-form-group>

      <b-form-group
        label-cols-sm="4"
        label-cols-lg="3"
        content-cols-sm
        content-cols-lg="8"
        :label="$store.state.localization.data.mainPage.drivers.tableColumns.description"
        label-for="input-horizontal"
      >
        <b-form-textarea
          v-model="description"
          style="font-size: 13px"
        ></b-form-textarea>
      </b-form-group>
    </div>
    <template v-slot:modal-footer="{ ok, cancel }">
      <b-button variant="success" style="font-size: 12px" @click="ok()">{{
        $store.state.localization.data.common.table.ok
      }}</b-button>
      <b-button variant="light" style="font-size: 12px" @click="cancel()">{{
        $store.state.localization.data.common.table.cancel
      }}</b-button>
    </template>
  </b-modal>
</template>

<script>
import { driverService, utilsService } from "../../../services";

export default {
  name: "CreateDriverPage",
  components: {},
  props: {
    vehicles: Array,
    companies: Array,
  },
  data() {
    return {
      lastName: null,
      firstName: null,
      patronymic: null,
      gender: null,
      rfid: null,
      phoneNumber: null,
      vehicleId: null,
      companyId: null,
      description: null,
      birthDate: null,
      isLastNameValid: null,
      isFirstNameValid: null,
      isGenderValid: null,
      isRfidValid: null,
      isCompanyValid: null,
    };
  },
  computed: {
    genderOptions() {
      const genderOptions = [];

      for (
        let i = 0;
        i <
        this.$store.state.localization.data.mainPage.drivers.genderOptions
          .length;
        i++
      ) {
        genderOptions.push({
          value:
            this.$store.state.localization.data.mainPage.drivers.genderOptions[
              i
            ].key,
          text: this.$store.state.localization.data.mainPage.drivers
            .genderOptions[i].value,
        });
      }
      return genderOptions;
    },
    vehicleOptions() {
      const vehicleOptions = [];

      for (let i = 0; i < this.vehicles.length; i++) {
        vehicleOptions.push({
          value: this.vehicles[i].id,
          text: this.vehicles[i].registerNumber,
        });
      }
      return vehicleOptions;
    },
    companyOptions() {
      const companyOptions = [];

      for (let i = 0; i < this.companies.length; i++) {
        companyOptions.push({
          value: this.companies[i].id,
          text: this.companies[i].name,
        });
      }
      return companyOptions;
    },
    calendarLocale() {
      return utilsService.getCalendarLocale(this.$store.state.localization.locale);
    }
  },
  methods: {
    async open() {
      this.firstName = null;
      this.lastName = null;
      this.patronymic = null;
      this.birthDate = null;
      this.rfid = null;
      this.phoneNumber = null;
      this.description = null;
      this.vehicleId = null;
      this.companyId = null;

      this.$refs["driver-card-modal"].show();
    },
    validate() {
      let isValid = true;

      if (!this.lastName) {
        this.isLastNameValid = false;
        isValid = false;
      } else {
        this.isLastNameValid = null;
      }

      if (!this.firstName) {
        this.isFirstNameValid = false;
        isValid = false;
      } else {
        this.isFirstNameValid = null;
      }

      if (!this.gender) {
        this.isGenderValid = false;
        isValid = false;
      } else {
        this.isGenderValid = null;
      }

      if (!this.rfid) {
        this.isRfidValid = false;
        isValid = false;
      } else {
        this.isRfidValid = null;
      }

      if (!this.companyId) {
        this.isCompanyValid = false;
        isValid = false;
      } else {
        this.isCompanyValid = null;
      }

      return isValid;
    },
    async driverCardModalOk(event) {
      if (!this.validate()) {
        event.preventDefault();
        return;
      }

      const driverCard = {
        firstName: this.firstName,
        lastName: this.lastName,
        patronymic: this.patronymic,
        birthDate: this.birthDate
          ? (this.birthDate.getTime() / 1000).toString()
          : null,
        rfid: this.rfid,
        gender: this.gender,
        phoneNumber: this.phoneNumber,
        description: this.description,
        vehicleId: this.vehicleId ? this.vehicleId.toString() : null,
        companyId: parseInt(this.companyId),
      };

      const createDriverResponse = await driverService.createDriver(driverCard);

      if (
        createDriverResponse.isSuccess &&
        createDriverResponse.data &&
        createDriverResponse.data.countInsertedRows != 0
      ) {
        this.$emit("driverCreatedSuccessEvent", driverCard);
      } else {
        this.$emit("driverCreatedFailEvent");
      }
    },
  },
};
</script>
